import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, switchMap } from 'rxjs';
import { TraceRequester } from 'src/app/requesters/trace/trace.requester';

import { TraceAdapter } from '../trace.adapter';
import {
	fetchTraceListPerPageFail,
	fetchTraceListPerPageSuccess,
	getTraceListPerPage,
} from './trace.actions';
import { TraceSelector } from './trace.selector';

@Injectable()
export class TraceEffects {
	// ##########################################################
	// Business Effects
	// ##########################################################

	public getTraceListPerPage$ = createEffect(() =>
		this.action$.pipe(
			ofType(getTraceListPerPage),
			switchMap((action) =>
				this.traceRequester.getTraces(action.offset, action.limit)
			),
			map((response) =>
				fetchTraceListPerPageSuccess({
					traceList: this.traceAdapter.generateTraceList(response.list),
					total: response.total,
				})
			),
			catchError((error: HttpErrorResponse, caught) => {
				console.error(error);
				this.store.dispatch(
					fetchTraceListPerPageFail({
						error,
					})
				);
				return caught;
			})
		)
	);

	public constructor(
		private readonly action$: Actions,
		private readonly traceRequester: TraceRequester,
		private readonly traceSelector: TraceSelector,
		private readonly traceAdapter: TraceAdapter,
		private readonly store: Store
	) {}
}
